<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :showAdd="true"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'vehicles/companies/',
      search: search,
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      @search="searchCar"
      :tagValue="selectedTag.split(',')"
      :searchTag="true"
      :searchValue="search"
      @selectedTags="searchTagIncar"
      :loading="searchLoading"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('search_for_license_and_fullname'),
        })
      "
      class="lg:col-span-2"
    >
      <el-form-item
        :label="$t('VEHCILE_NAME')"
        v-loading="vehicleLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :placeholder="$t('SELECT_PLACEHOLDER')"
          v-model="selectedVehicleName"
          clearable
          filterable
          :multiple="true"
          :collapseTags="true"
          @change="vehicleNameFilterChange"
        >
          <el-option-group
            v-for="group in carList"
            :key="group.id"
            :label="$i18n.locale == 'fa' ? group.fa_title : group.en_title"
          >
            <el-option
              v-for="item in group.vehicles"
              :key="item.id"
              :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
              :value="item.id"
            ></el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
    </tableSearch>

    <customDialog
      v-if="imeiVisible"
      :title="$t('HARDWARE_ALLOCATION')"
      childClass="info_msg"
      :show="imeiVisible"
      @show="imeiVisible = $event"
      @confirmButn="submitIMEI(selectedId, 'add')"
      form="true"
    >
      <el-form
        status-icon
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-1 gap-4 status-icon"
      >
        <el-form-item
          :label="$t('IMEI')"
          prop="imei"
          v-loading="dialogLoading"
          element-loading-spinner="el-icon-loading"
        >
          <el-select
            :placeholder="$t('SELECT_PLACEHOLDER')"
            v-model="ruleForm.imei"
            clearable
            filterable
          >
            <el-option
              v-for="item in imeiList"
              :key="item.id"
              :label="item.imei"
              :value="[item.id, item.imei]"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-slot:footerConfirm>
          <el-button type="success" @click="submitForm('ruleForm')">
            {{ $t('SUBMIT') }}
          </el-button>
        </template>
      </el-form>
    </customDialog>

    <FuelTransactionForm
      :show.sync="fuelDialog"
      :selectedVehicle="selectedVehicle"
      :selectedDriver="selectedDriverId"
      :currentOdometer="selectedOdometer"
    />

    <customDialog
      v-if="driverVisible"
      :title="$t('DRIVER_ALLOCATION')"
      childClass="info_msg"
      :show="driverVisible"
      @show="driverVisible = $event"
      @confirmButn="submitDriver(selectedId, 'add')"
      width="30%"
    >
      <el-form
        status-icon
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-1 gap-4 status-icon"
      >
        <el-form-item
          :label="$t('DRIVER_TITLE')"
          prop="driver"
          v-loading="dialogLoading"
          element-loading-spinner="el-icon-loading"
        >
          <el-select
            :placeholder="$t('SELECT_PLACEHOLDER')"
            v-model="ruleForm.driver"
            clearable
            filterable
          >
            <el-option
              v-for="item in driverList"
              :key="item.id"
              :label="item.first_name + ' ' + item.last_name"
              :value="[item.id, item.first_name, item.last_name]"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </customDialog>

    <div v-if="tableData.results" class="flex justify-end mb-4">
      <el-button
        :loading="isDownloadLoading"
        type="info"
        size="small"
        round
        @click="downloadReport()"
      >
        {{ $t('DOWNLOAD_VEHCILE_LIST') }}
      </el-button>
    </div>

    <el-table
      :empty-text="$t('NO_DATA')"
      v-loading="loading"
      :stripe="true"
      ref="filterTable"
      :data="tableData.results"
      :default-sort="{ prop: 'id', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="vehicle"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="150"
      >
        <template slot-scope="scope">
          <div
            class="information right cursor-pointer"
            v-if="scope.row.device != null"
            @click="showSimNum(scope.row.device.sim_number)"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                $t('SIM_NUMBER') + ': ' + '0' + scope.row.device.sim_number
              "
              placement="bottom"
            >
              <LicensePlate
                :vehicle="scope.row.vehicle"
                :color="scope.row.color"
                :license_plate="scope.row.license_plate"
                :chars="alphaList"
              ></LicensePlate>
            </el-tooltip>
          </div>
          <LicensePlate
            v-else
            :vehicle="scope.row.vehicle"
            :color="scope.row.color"
            :license_plate="scope.row.license_plate"
            :chars="alphaList"
          ></LicensePlate>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DRIVER_TITLE')"
        width="140"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DRIVER_TITLE')">
            {{
              scope.row.driver
                ? scope.row.driver.first_name + ' ' + scope.row.driver.last_name
                : ''
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        sortable
        :sort-method="sortThird"
        prop="total_odometer"
        align="center"
        :label="$t('CURRENT_TOTAL_ODOMETER')"
        width="120"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('CURRENT_TOTAL_ODOMETER')"
            class="text-center"
            v-html="
              $options.filters.numberSeperator1(scope.row.total_odometer / 1000)
            "
          ></div>
        </template>
      </el-table-column>

      <el-table-column
        sortable
        :sort-method="sorttWork"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('WORKING_STATUS')"
        width="140"
      >
        <template slot-scope="scope">
          <div :data-title="$t('WORKING_STATUS')">
            <StatusHolder v-if="scope.row.status" :status="scope.row.status" />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        sortable
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('OWNERSHIP')"
        width="140"
      >
        <template slot-scope="scope">
          <div :data-title="$t('OWNERSHIP')">
            <StatusHolder
              v-if="scope.row.ownership"
              :status="scope.row.ownership"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TAG')"
        width="80"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TAG')">
            <div
              class="flex flex-row flex-wrap items-center"
              v-if="scope.row.company_vehicle_tags.length"
            >
              <span
                class="text-xs"
                v-for="(tag, index) in scope.row.company_vehicle_tags"
                :key="tag.id"
              >
                {{ $i18n.locale == 'fa' ? tag.fa_title : tag.en_title }}
                <span
                  class="text-gray-400"
                  v-if="
                    scope.row.company_vehicle_tags.length > 1 &&
                    index != scope.row.company_vehicle_tags.length - 1
                  "
                >
                  ,
                </span>
              </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label=""
        width="280"
        prop="tag"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <div class="fixed-column carsList">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('description')"
              placement="bottom"
            >
              <i
                v-if="
                  scope.row.description != null && scope.row.description != ''
                "
                class="
                  el-icon-chat-dot-square
                  text-xl
                  cursor-pointer
                  text-blue-700
                "
                @click="open(scope.row.description)"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.driver != null"
              class="item"
              effect="dark"
              :content="$t('DELETE') + ' ' + $t('DRIVER_TITLE')"
              placement="bottom"
            >
              <el-popconfirm
                :confirm-button-text="$t('YES')"
                :cancel-button-text="$t('NO')"
                icon="el-icon-info"
                icon-color="red"
                :title="
                  ' راننده ای به نام' +
                  ' ' +
                  scope.row.driver.first_name +
                  ' ' +
                  scope.row.driver.last_name +
                  ' ' +
                  'به این وسیله نقلیه اخصاص داده شده است. آیا مایل به حذف آن هستید؟ '
                "
                @confirm="submitDriver(scope.row.id, 'delete')"
              >
                <el-button slot="reference" type="text" style="padding: 0">
                  <i
                    class="el-icon-user text-xl cursor-pointer text-green-500"
                  ></i>
                </el-button>
              </el-popconfirm>
            </el-tooltip>

            <el-tooltip
              v-if="scope.row.driver == null"
              class="item"
              effect="dark"
              :content="$t('DRIVER_ALLOCATION')"
              placement="bottom"
            >
              <i
                @click="
                  driverVisible = true
                  loadDriver()
                  selectedId = scope.row.id
                "
                class="el-icon-user text-xl cursor-pointer text-gray-500"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.device != null"
              class="item"
              effect="dark"
              :content="$t('DELETE') + ' ' + $t('HARDWARE_TITLE')"
              placement="bottom"
            >
              <el-popconfirm
                :confirm-button-text="$t('YES')"
                :cancel-button-text="$t('NO')"
                icon="el-icon-info"
                icon-color="red"
                :title="
                  ' سخت‌افزاری با سریال ' +
                  ' ' +
                  scope.row.device.imei +
                  ' ' +
                  'به این وسیله نقلیه، اخصاص داده شده است. آیا مایل به حذف آن هستید؟ '
                "
                @confirm="submitIMEI(scope.row.id, 'delete')"
              >
                <el-button slot="reference" type="text" style="padding: 0">
                  <i
                    class="el-icon-cpu text-xl cursor-pointer text-green-500"
                  ></i>
                </el-button>
              </el-popconfirm>
            </el-tooltip>

            <el-tooltip
              v-if="scope.row.device == null"
              class="item"
              effect="dark"
              :content="$t('HARDWARE_ALLOCATION')"
              placement="bottom"
            >
              <i
                @click="
                  imeiVisible = true
                  loadImei()
                  selectedId = scope.row.id
                "
                class="el-icon-cpu text-xl cursor-pointer text-gray-500"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('fuel_transaction_management')"
              placement="bottom"
            >
              <i
                class="el-icon-s-finance text-xl cursor-pointer text-red-500"
                @click="openFuelDialog(scope.row)"
              ></i>
            </el-tooltip>

            <tableFeatures
              :description="scope.row.description"
              :router="{
                name: 'EDIT_VEHICLE',
                id: scope.row.id,
              }"
              :title="$t('VEHICLE_TITLE')"
              :isDeleteable="false"
              :showDesc="false"
              @view="view($event, 'VIEW_VEHICLE')"
              :view="true"
            >
              <setOrg
                :organizationsId="scope.row.organizations"
                :id="scope.row.id"
                type="vehicle"
              />
              <AddFine
                :company_vehicle="scope.row.id"
                :driver="scope.row.driver && scope.row.driver.id"
              />
            </tableFeatures>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>
<script>
import {
  carsListCustomer,
  removeCar,
  driverAssign,
  deviceAssign,
  downloadCarsList,
} from '@/api/cars'
import { carsList } from '@/api/global'
import customDialog from '@/components/elements/dialog'
import setOrg from '@/components/elements/set-org'
import tableSearch from '@/components/elements/tableSearch'
import tableFeatures from '@/components/elements/tableFeatures'
import { notUsedDrivers, imeiList, licenseChars } from '@/api/global'
import AddFine from './components/add-fines'
import { fuels, fuelType_ } from '@/api/fuel'
import LicensePlate from '@/components/cars/LicensePlate'
import StatusHolder from '@/components/elements/statusHolder'
import { open } from '@/mixins/openDesc'
import { view } from '@/mixins/viewPage'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { resetForm } from '@/mixins/resetForm'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { driverSummary } from '@/api/drivers'
import FuelTransactionForm from '@/components/fuel/FuelTransactionForm.vue'
import { reverseCurrency } from '@/mixins/reverseCurrency'

export default {
  mixins: [
    open,
    view,
    gregorianToJalali,
    resetForm,
    jalaliToGregorian,
    reverseCurrency,
  ],
  data() {
    return {
      isDownloadLoading: false,

      tableData: {
        results: [],
      },
      fuelDialog: false,
      imeiVisible: false,
      driverVisible: false,
      fuels: [],
      fuelLoading: true,
      fuelsType: [],
      fuelsTypeLoading: true,
      selectedId: '',
      loading: true,
      searchLoading: false,
      selectedVehicle: null,
      selectedOdometer: null,
      selectedDriverId: null,
      dialogLoading: true,
      imeiList: [],
      selectedTag: '',
      selectedVehicleName: '',
      carList: [],
      vehicleLoading: true,
      driversList: [],
      driversListLoading: true,
      driverList: [],
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],
      search: '',
      ruleForm: {
        imei: '',
        driver: '',
      },
      rules: {
        imei: [
          {
            required: true,
            trigger: 'blur',
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('IMEI'),
            }),
          },
        ],
        driver: [
          {
            required: true,
            trigger: 'blur',
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('DRIVER_TITLE'),
            }),
          },
        ],
      },
    }
  },
  components: {
    customDialog,
    FuelTransactionForm,
    setOrg,
    tableSearch,
    tableFeatures,
    LicensePlate,
    StatusHolder,
    AddFine,
    // VehicleSelect,
  },
  methods: {
    openFuelDialog(vehicle) {
      this.selectedVehicle = vehicle.id
      this.selectedOdometer = vehicle.total_odometer
      this.selectedDriverId = vehicle.driver ? vehicle.driver.id : ''
      this.fuelDialog = true
    },

    handleTransactionAdded(newTransaction) {
      this.$notify.success({
        title:
          this.$t('Add_fuel_transaction') + ' ' + this.$t('SUCCESSFULLY_DONE'),
        duration: 5000,
        customClass: 'succ_msg',
      })
    },
    downloadReport() {
      this.isDownloadLoading = true
      downloadCarsList
        .api()
        .then((res) => {
          this.isDownloadLoading = false
          if (res) {
            var blob = new Blob([res], { type: 'application/octet-stream' })

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = `vehicles-CARPO.xlsx`
            document.body.appendChild(a)
            a.click()

            window.URL.revokeObjectURL(url)
          }
        })
        .catch((error) => {
          console.error('Download Error:', error)
        })
    },
    showSimNum(num) {
      this.$message({
        showClose: true,
        message: ` ${this.$i18n.t(
          'SIM_NUMBER'
        )}: <b class="text-black">0${num}</b>`,
        dangerouslyUseHTMLString: true,
      })
    },
    debounce(func, timeout = 300) {
      let timer
      return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          func.apply(this, args)
        }, timeout)
      }
    },

    sortThird(a, b) {
      if (a.total_odometer < b.total_odometer) return -1
      if (a.total_odometer > b.total_odometer) return 1
      return 0
    },
    sortVehicle(a, b) {
      if (a.vehicle_insurance_expiry_date < b.vehicle_insurance_expiry_date)
        return -1
      if (a.vehicle_insurance_expiry_date > b.vehicle_insurance_expiry_date)
        return 1
      return 0
    },

    remove(id) {
      removeCar.api(id).then((res) => {
        if (res) {
          this.$notify.success({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('WORKING_STATUS'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.tableData.results = this.tableData.results.filter(
            (table) => table.id !== id
          )
        }
      })
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter()
    },

    sorttWork(a, b) {
      if (a.working < b.working) return -1
      if (a.working > b.working) return 1
      return 0
    },

    submitIMEI(rowId = null, type) {
      if (this.ruleForm.imei == '' && type == 'add') {
        this.$notify.error({
          title: 'سریال IMEI سخت‌افزار نباید خالی باشد. ',
          duration: 4000,
          customClass: 'error_msg',
        })
        return
      }

      var actionPayload, customTitle

      if (type == 'add') {
        actionPayload = {
          id: this.selectedId,
          device: this.ruleForm.imei[0],
        }

        customTitle =
          'سخت‌افزار انتخاب شده، به وسیله نقلیه ی مورد نظر با موفقیت اختصاص داده شد'
      } else {
        actionPayload = {
          device: null,
          id: rowId,
        }
        customTitle = 'با موفقیت حذف شد'
      }
      deviceAssign.api(actionPayload).then((res) => {
        if (res) {
          this.imeiList = []
          this.imeiVisible = false

          if (type === 'add') {
            this.tableData.results.map((table) =>
              table.id == this.selectedId
                ? (table.device = {
                    id: this.ruleForm.imei[0],
                    imei: this.ruleForm.imei[1],
                  })
                : table.device
            )
          } else {
            this.ruleForm.imei = ''
            this.tableData.results.map((table) =>
              table.id == rowId ? (table.device = null) : table.device
            )
          }

          this.$notify.success({
            title: customTitle,
            duration: 4000,
            customClass: 'info_msg',
          })
        }
      })
    },
    submitDriver(rowId, type) {
      if (this.ruleForm.driver == '' && type == 'add') {
        this.$notify.error({
          title: 'نام راننده نباید خالی باشد. ',
          duration: 4000,
          customClass: 'error_msg',
        })
        return
      }
      var customTitle, actionPayload
      if (type == 'add') {
        this.driverVisible = false
        customTitle =
          'راننده ی انتخاب شده، به وسیله نقلیه ی مورد نظر با موفقیت اختصاص داده شد'
        actionPayload = {
          id: this.selectedId,
          driver: this.ruleForm.driver[0],
        }
      } else {
        actionPayload = {
          id: rowId,
          driver: null,
        }

        customTitle = 'با موفقیت حذف شد'
      }
      driverAssign.api(actionPayload).then((res) => {
        if (res) {
          this.driverList = []
          if (type === 'add') {
            this.tableData.results.map((table) =>
              table.id == this.selectedId
                ? (table.driver = {
                    id: this.ruleForm.driver[0],
                    first_name: this.ruleForm.driver[1],
                    last_name: this.ruleForm.driver[2],
                  })
                : table.driver
            )
          } else {
            this.ruleForm.driver = ''
            this.tableData.results.map((table) =>
              table.id == rowId ? (table.driver = null) : table.driver
            )
          }
          this.$notify.success({
            title: customTitle,
            duration: 4000,
            customClass: 'info_msg',
          })
        }
      })
      // driverAssignHistory.api(historyPayload).then((res) => {
      //   // console.log(res);
      // })
    },
    loadImei() {
      this.dialogLoading = true
      imeiList.api().then((res) => {
        if (res) {
          this.imeiList = res
          this.dialogLoading = false
        }
      })
    },
    loadDriver() {
      this.dialogLoading = true
      notUsedDrivers.api().then((res) => {
        if (res) {
          this.driverList = res
          this.dialogLoading = false
        }
      })
    },
    vehicleNameFilterChange(val) {
      this.selectedVehicleName = val
      this.tableData = []
      this.loading = true
      this.searchLoading = true

      // Update query parameters
      const query = {
        ...this.$route.query,
        vehicle__id__in: this.selectedVehicleName,
      }
      if (this.$route.query.p) delete query.p // Remove 'p' if it exists
      this.$router.replace({ query })

      setTimeout(() => {
        carsListCustomer
          .api(this.search, this.selectedTag, this.selectedVehicleName)
          .then((res) => {
            if (res) {
              this.tableData = res
              this.loading = false
              this.searchLoading = false
            }
          })
      }, 300)
    },

    searchTagIncar(val) {
      this.tableData = []
      this.loading = true
      this.searchLoading = true
      this.selectedTag = val.join(',')

      // Update query parameters
      const query = {
        ...this.$route.query,
        company_vehicle_tags__id__in: this.selectedTag,
      }
      if (this.$route.query.p) delete query.p // Remove 'p' if it exists
      this.$router.replace({ query })

      setTimeout(() => {
        carsListCustomer
          .api(this.search, this.selectedTag, this.selectedVehicleName)
          .then((res) => {
            if (res) {
              this.tableData = res
              this.loading = false
              this.searchLoading = false
            }
          })
      }, 300)
    },

    searchCar(val) {
      this.search = val
      this.tableData = []
      this.loading = true
      this.searchLoading = true

      // Update query parameters
      const query = { ...this.$route.query, search: this.search }
      if (this.$route.query.p) delete query.p // Remove 'p' if it exists
      this.$router.replace({ query })

      setTimeout(() => {
        carsListCustomer
          .api(val, this.selectedTag, this.selectedVehicleName)
          .then((res) => {
            if (res) {
              this.tableData = res
              this.loading = false
              this.searchLoading = false
            }
          })
      }, 300)
    },
  },
  mounted() {
    const { search, company_vehicle_tags__id__in, vehicle__id__in } =
      this.$route.query

    // Initialize search, selectedTag and selectedVehicleName
    this.search = search || ''
    this.selectedTag = company_vehicle_tags__id__in || ''
    this.selectedVehicleName = vehicle__id__in || ''

    // Load car list for vehicle name filter
    carsList.api().then((res) => {
      if (res) {
        this.vehicleLoading = false
        this.carList = res
      }
    })

    carsListCustomer
      .api(this.search, this.selectedTag, this.selectedVehicleName)
      .then((res) => {
        if (res) {
          this.tableData = res
        }
        this.loading = false
      })
    licenseChars.api().then((res) => {
      this.alphaList = res
    })

    fuelType_.api().then((res) => {
      if (res) {
        this.fuelsType = res
        this.fuelsTypeLoading = false
      }
    })
    driverSummary.api().then((res) => {
      if (res) {
        this.driversList = res
        this.driversListLoading = false
      }
    })
  },
  computed: {
    maxDate() {
      let todayDate = new Date()
        .toLocaleDateString('en-us')
        .replaceAll('/', '-')
        .split('-')
      todayDate = `${todayDate[2]}-${todayDate[0]}-${todayDate[1]}`
      return this.gregorianToJalali(todayDate, 'fa')
    },
  },
}
</script>
